import { render, staticRenderFns } from "./SalesPersonWidget.vue?vue&type=template&id=1ce0804c&"
import script from "./SalesPersonWidget.vue?vue&type=script&lang=js&"
export * from "./SalesPersonWidget.vue?vue&type=script&lang=js&"
import style0 from "./SalesPersonWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports